module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/truck-25dd03aaebedd7687ff235544102db89.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/truck.svg
// module id = SJ1D
// module chunks = 24